<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal")
                v-icon(color="basic800" :size="24") mdi-close
            v-col.ml-3
              p.mb-0.h6.basic800--text {{ $t('variants_of') }} {{ parentOption.name }}

        v-card-text.pa-0
          div.pa-4.d-flex.align-center
            div.p2 {{ $t('rearrange_your_variants') }} 
            v-spacer
            v-btn(depressed small color="success500" :loading="isLoading" @click="save")
              .button-AA-tiny.white--text {{ $t('save') }}
          
          v-container.px-1.py-0(style="max-width:600px")
            .contain-layout
              draggable.my-2(tag="div" handle=".handle" :list="specs" @start="drag = true" @end="endMove")
                template(v-for="(spec, specIndex) in specs")
                  v-card(flat :key="specIndex")
                    v-row.pa-4(no-gutters)
                      v-col
                        div.p1 {{ spec.value }}
                      v-spacer
                      v-col.shrink.align-self-center.handle.clickable(:class="{ 'drag-active': drag }")
                        ArrowsSortIcon.mx-1.mb-n1(size="20" :style="{ 'color': $vuetify.theme.themes[$theme].basic700 }")
                    v-divider.basic300(v-if="specIndex !== specs.length-1")

</template>

<script>
import draggable from 'vuedraggable'
import clone from 'just-clone'

export default {
  name: 'RearrangeVariant',
  components: {
    draggable
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    parentOption: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      specs: [],
      isLoading: false,
      drag: false,
    }
  },
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted() {
    this.specs = clone(this.parentOption.specs)
  },
  methods: {
    endMove () {
      this.drag = false
    },
    save() {
      this.isLoading = true
      this.$emit('updateData', this.specs)
      this.showModal = false
    }
  }
}
</script>

<style scoped>
.drag-inactive { cursor: grab; }
.drag-active { cursor: grabbing; }
</style>

<i18n>
{
  "en": {
    "variants_of": "Variants of",
    "rearrange_your_variants": "Rearrange your variants "
  },
  "id": {
    "variants_of": "Varian untuk",
    "rearrange_your_variants": "Atur varian "
  }
}
</i18n>
